/**
 * Created by Lasse Einfeldt
 * User: LEinfeldt on 15.05.2018
 * Copyright: xdot GmbH 2018
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { Button, ButtonGroup, Dropdown } from 'external/react-bootstrap';

const FliwasActionButtons = ({ classNames = '', pullRight = true, dropup = false, children }) => {

    const elems = React.Children.toArray(children);
    const filteredChildren = elems.slice(1);
    const onClick = elems[0].props.onClick || elems[0].props.onSelect;
    const { eventKey } = elems[0].props;
    const title = elems[0].props.title;
    return (
        <Dropdown
            className={classNames}
            as={ButtonGroup}
            drop={dropup ? 'up' : 'down'}
            alignRight={pullRight}
        >
            <Button
                variant="primary"
                onClick={eventKey ? onClick.bind(null, eventKey) : onClick}
            >
                {title}
            </Button>

            <Dropdown.Toggle
                split
                variant="primary"
                id={`dropdown-${title}`}
            >
                <i className="fa fa-caret-down"/>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {filteredChildren}
            </Dropdown.Menu>
        </Dropdown>
    );
};

FliwasActionButtons.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    pullRight: PropTypes.bool,
    dropup: PropTypes.bool,
    classNames: PropTypes.string
};

export default FliwasActionButtons;



// WEBPACK FOOTER //
// ./js/components/FliwasActionButtons.jsx